import { List } from 'immutable'
import { declareResourceType, IKeyMap } from '@rwwa/rwwa-data-access'
import { TypedRecord, recordify } from 'typed-immutable-record'
import { fetchData } from '../helpers'

export const CurrentGoodThingsKey = 'current'

export interface IGoodThing {
  key: string
  updatedAt: string
  raceKey: string
  fixtureDate: string
  fixtureId: string
  raceNumber: number
  acceptorNumber: number
  rating?: number
  recommendedOdds?: number
}

export type ICurrentGoodThings = List<string>

export interface IGoodThingRecord extends TypedRecord<IGoodThingRecord>, IGoodThing {}

export const GiddyUpGoodThings = declareResourceType<IGoodThingRecord, IGoodThing>({
  typeKey: 'giddyUpGoodThings',
  map: goodThing => recordify<IGoodThing, IGoodThingRecord>(goodThing),
  ownedBy: () => ['giddyUpGoodThingsByDate', CurrentGoodThingsKey],
})

export const CurrentGoodThings = declareResourceType<ICurrentGoodThings, IGoodThing>({
  typeKey: 'giddyUpGoodThingsByDate',
  fetchSingle: key => fetchData(`goodThings/${key}`) as Promise<IKeyMap<IKeyMap<IGoodThing>>>,
  map: list => List<string>(list),
  maxToKeep: 1,
  softTimeToLive: 60000,
})
